'use client';

import type { HTMLAttributes } from 'react';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { useIntl } from 'react-intl';
import { selectedQuantity } from '../atoms';
import { quantitySelectionMessages } from './messages';
import {
  QuantitySelection,
  type QuantitySelectionProps,
} from '../QuantitySelection/QuantitySelection.client';

export type QuantitySelectionAtomizedProps = HTMLAttributes<HTMLDivElement> & {
  quantitySelectionProps?: QuantitySelectionProps;
  hideLabel?: boolean;
};

export const QuantitySelectionAtomized = ({
  hideLabel = false,
  quantitySelectionProps,
  ...props
}: QuantitySelectionAtomizedProps) => {
  const [atomQuantity, setAtomQuantity] = useAtom(selectedQuantity);
  const { formatMessage } = useIntl();

  // Quantity will be updated, if user uses miniDV
  useEffect(() => {
    if (quantitySelectionProps?.quantity) {
      setAtomQuantity(quantitySelectionProps.quantity);
    }
  }, [quantitySelectionProps?.quantity, setAtomQuantity]);

  return (
    <div {...props}>
      {!hideLabel && (
        <div className="text-size-body1 mb-1 leading-2.5 font-normal select-none">
          {formatMessage(quantitySelectionMessages.label)}
        </div>
      )}
      <QuantitySelection
        {...quantitySelectionProps}
        onUpdate={(value) => {
          setAtomQuantity(value);
        }}
        quantity={atomQuantity}
      />
    </div>
  );
};
